import { render, staticRenderFns } from "./BlindDetails.vue?vue&type=template&id=28f67e48&scoped=true"
import script from "./BlindDetails.vue?vue&type=script&lang=js"
export * from "./BlindDetails.vue?vue&type=script&lang=js"
import style0 from "./BlindDetails.vue?vue&type=style&index=0&id=28f67e48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f67e48",
  null
  
)

export default component.exports